import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { i18nReady } from '@/i18n';
import { observeDigits } from '@/i18n/localeDigits';
import { AppIslands } from './AppIslands';
import { openModal } from './modal-bus';
import './components/index';

document.addEventListener('DOMContentLoaded', () => {
    // Национальные цифры локали (bn) в light DOM: серверный HTML уже приведён
    // middleware LocalizeDigits, наблюдатель добирает то, что дорисовывает JS —
    // острова с data-no-shadow (TestProcess, TestResult), легаси-виджеты.
    // Shadow-корни островов наблюдает ShadowMount. Для прочих языков — no-op.
    observeDigits(document.body);

    const root = document.getElementById('islands-root');
    if (root) {
        // Локали грузятся лениво (см. src/i18n.ts) — ждём словарь до первого
        // рендера, иначе острова отрисуют сырые ключи переводов.
        void i18nReady.then(() => {
            ReactDOM.createRoot(root).render(
                <StrictMode>
                    <AppIslands />
                </StrictMode>
            );
        });
    }

    // Делегированный обработчик для data-react-modal триггеров
    document.addEventListener('click', (e) => {
        const trigger = (e.target as Element).closest('[data-react-modal]');
        if (!trigger) return;

        const name = trigger.getAttribute('data-react-modal') ?? '';
        const propsRaw = trigger.getAttribute('data-modal-props') ?? '{}';
        let props: Record<string, unknown> = {};
        try { props = JSON.parse(propsRaw); } catch { /* malformed props */ }

        openModal(name, props);
    });
});
